[
  {
    "id": "chapter:7a",
    "q": "When changing lanes identify a:",
    "answer": {
      "text": "4 to 6 second gap in traffic",
      "section": 7,
      "topic": "Space to Merge",
      "page": 64
    },
    "otherChoices": ["2 to 3 second gap in traffic", "3 to 4 second gap in traffic"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:7b",
    "q": "Having a Driver’s License is a:",
    "answer": {
      "text": "Privilege, not a right",
      "section": 7,
      "topic": "Be a Safe and Responsible Driver",
      "page": 70
    },
    "otherChoices": ["Right, not a privilege", "Requirement"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:7c",
    "q": "When overtaking a pedestrian who is walking along the roadway and an oncoming vehicle is approaching:",
    "answer": {
      "text": "Slow down and let the vehicle pass first",
      "section": 7,
      "topic": "Minimizing Hazards",
      "page": 67
    },
    "otherChoices": [
      "Keep driving, the oncoming vehicle must stop for you",
      "Honk your horn so the pedestrian moves over"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "sample:2",
    "q": "Continue to pass another vehicle until:",
    "answer": {
      "text": "The complete front of the passed vehicle is visible in your rearview mirror",
      "section": 7,
      "topic": "Space to Pass",
      "page": 65
    },
    "otherChoices": [
      "You look in your side mirror and see the vehicle is behind you",
      "The driver you just passed signals you to move over to their lane"
    ],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:2:derived:a",
    "q": "When passing another vehicle, pass from at least:",
    "answer": {
      "text": "Two seconds behind the vehicle to be passed",
      "section": 7,
      "topic": "Space to Pass",
      "page": 65
    },
    "otherChoices": ["Four seconds behind the vehicle to be passed", "One car length behind the vehicle to be passed"],
    "generated": {
      "parent": "sample:2",
      "type": "paired",
      "rationale": "Paired counterpart of sample:2 sourced from the same Space to Pass bullet on page 65: 'Pass from at least two seconds behind the vehicle to be passed to avoid striking the rear side of the vehicle.' Question stem and answer split that sentence at the natural pivot, mirroring how sample:2 splits its own handbook sentence at 'until:'. Distractors are simple numeric and length variants in the same grammatical form, paralleling how sample:2's distractors are alternative completions rather than handbook quotes."
    },
    "batch": "review-20260502b",
    "version": 2,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "sample:5",
    "q": "What is the average perception time for an alert driver?",
    "answer": {
      "text": "¾ second to 1 second",
      "section": 7,
      "topic": "Perception Distance",
      "page": 58
    },
    "otherChoices": ["3 seconds to 4 seconds", "1 second to 2 seconds"],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:5:derived:a",
    "q": "What is the minimum total stopping distance at 50 mph in ideal conditions?",
    "answer": {
      "text": "268 feet",
      "section": 7,
      "topic": "Total Stopping Distance",
      "page": 58
    },
    "otherChoices": ["55 feet", "158 feet"],
    "generated": {
      "parent": "sample:5",
      "type": "paired",
      "rationale": "Paired counterpart of sample:5 sourced from the same Speed Management / Stopping teaching on page 58. Where sample:5 asks for the perception time, this variant asks for the total stopping distance at 50 mph. Distractors are the discrete distances taught in the same paragraph cluster: 55 feet (reaction distance at 50 mph) and 158 feet (braking distance at 50 mph)."
    },
    "batch": "review-20260502",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "sample:11",
    "q": "Roadways are more slippery when:",
    "answer": {
      "text": "It first starts to rain, snow or sleet",
      "section": 7,
      "topic": "Slippery Roads",
      "page": 59
    },
    "otherChoices": [
      "It has been raining, snowing, or sleeting for awhile",
      "It has just stopped raining, snowing, or sleeting"
    ],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:11:derived:a",
    "q": "If there is packed snow on the road, you should reduce your speed by:",
    "answer": {
      "text": "Half or more",
      "section": 7,
      "topic": "Slippery Roads",
      "page": 59
    },
    "otherChoices": [
      "About 10 mph below the recommended speed",
      "Nothing if the vehicle is equipped with studded snow tires"
    ],
    "generated": {
      "parent": "sample:11",
      "type": "paired",
      "rationale": "Paired counterpart of sample:11 sourced from the same Slippery Roads paragraph cluster on page 59. Where sample:11 covers when a road becomes slippery, this variant covers how much to slow down for packed snow: 'If there is packed snow on the road, reduce your speed by half or more.' The 10 mph distractor is the handbook's wet-roadway speed reduction taught in the immediately preceding sentence and tempts drivers who conflate wet with snow-packed. The studded-tire distractor is drawn from the same page's note that studded snow tires are allowed November 1st to April 1st and tempts drivers who assume the equipment removes the speed-reduction rule."
    },
    "batch": "review-20260502b",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "authored:s7-following-distance",
    "q": "Keep a minimum following distance of:",
    "answer": {
      "text": "Two seconds with an additional second for any unusual weather or traffic conditions",
      "section": 7,
      "topic": "Space Ahead",
      "page": 62
    },
    "otherChoices": [
      "Smaller near intersections, where the vehicles ahead are easy to see",
      "Just enough to stop once the vehicle ahead shows its brake lights"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 2,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s7-headlights-with-wipers",
    "q": "Kansas law requires you to turn on your headlights:",
    "answer": {
      "text": "Whenever the wipers are used on the vehicle",
      "section": 7,
      "topic": "Communicating",
      "page": 67
    },
    "otherChoices": ["At all times while the vehicle is operating", "At the driver’s discretion"],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s7-max-speed-separated-multilane",
    "q": "Unless otherwise posted, the maximum speed limit on any separated multilane highway is:",
    "answer": {
      "text": "75 mph",
      "section": 7,
      "topic": "Obeying Appropriate Speed Limits",
      "page": 62
    },
    "otherChoices": ["65 mph", "55 mph"],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s7-look-ahead-city",
    "q": "In the city, you should look at least:",
    "answer": {
      "text": "Two blocks or two traffic signals ahead",
      "section": 7,
      "topic": "Visual Search, Look ahead",
      "page": 56
    },
    "otherChoices": ["200 feet ahead", "One-half mile ahead"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s7-look-ahead-urban-area",
    "q": "In an urban area, you should look at least:",
    "answer": {
      "text": "Three blocks or three traffic signals ahead",
      "section": 7,
      "topic": "Visual Search, Look ahead",
      "page": 56
    },
    "otherChoices": ["400 feet ahead", "One mile ahead"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s7-look-ahead-highway",
    "q": "On the highway, you should look at least:",
    "answer": {
      "text": "A quarter of a mile ahead",
      "section": 7,
      "topic": "Visual Search, Look ahead",
      "page": 56
    },
    "otherChoices": ["One-half mile ahead", "100 feet ahead"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s7-double-speed-impact",
    "q": "When you double your speed from 20 to 40 mph, the impact and braking distance are:",
    "answer": {
      "text": "4 times greater",
      "section": 7,
      "topic": "Speed Management, Stopping",
      "page": 59
    },
    "otherChoices": ["2 times greater", "8 times greater"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 2,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s7-triple-speed-impact",
    "q": "When you triple your speed from 20 to 60 mph, the impact and braking distance are:",
    "answer": {
      "text": "9 times greater",
      "section": 7,
      "topic": "Speed Management, Stopping",
      "page": 59
    },
    "otherChoices": ["3 times greater", "27 times greater"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s7-hydroplaning",
    "q": "As you go faster than 35 mph on a wet road, the steering tires will start to ride up on any pooled water. This tire loss of roadway contact is called:",
    "answer": {
      "text": "Hydroplaning",
      "section": 7,
      "topic": "Speed Management, Water on the roadway",
      "page": 60
    },
    "otherChoices": ["Skidding", "The inertia effect"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s7-drive-center-of-lane",
    "q": "In general, it is safest to drive:",
    "answer": {
      "text": "In the center of your lane",
      "section": 7,
      "topic": "Space Management, Space to the Side",
      "page": 64
    },
    "otherChoices": ["To the left portion of your lane space", "To the right side of your lane"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 3,
    "updatedAt": "2026-08-04",
    "status": "verified"
  },
  {
    "id": "authored:s7-acceleration-lane",
    "q": "When entering a multiple-lane, limited access roadway, use the acceleration lane to:",
    "answer": {
      "text": "Reach the speed of other vehicles before pulling onto the roadway",
      "section": 7,
      "topic": "Speed Management, Entering traffic flow",
      "page": 60
    },
    "otherChoices": [
      "Drive to the end of the lane and stop until a gap opens in traffic",
      "Cross the solid white line as soon as the lane appears"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s7-tailgater-response",
    "q": "If your vehicle is being tailgated by another driver and there is an empty lane:",
    "answer": {
      "text": "Move over to the empty lane and allow a pass",
      "section": 7,
      "topic": "Space Management, Space Behind",
      "page": 64
    },
    "otherChoices": [
      "Slow down quickly to discourage the tailgater",
      "Speed up to hold-your-own in your path of travel"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s7-abs-basics",
    "q": "The basics for ABS (Anti-Lock Braking System) usage are:",
    "answer": {
      "text": "Search (for open space), Stomp (on the brake pedal firmly), Steer (to the open space)",
      "section": 7,
      "topic": "Traction Technology",
      "page": 62
    },
    "otherChoices": [
      "Rapidly pump the brake pedal several times",
      "Ease up on the brake pedal and then reapply with control"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s7-avoid-speeding-speedometer",
    "q": "The best way to avoid speeding is to:",
    "answer": {
      "text": "Check your speedometer frequently",
      "section": 7,
      "topic": "Obeying Appropriate Speed Limits",
      "page": 62
    },
    "otherChoices": [
      "Rely on your sense of how fast you are going",
      "Assume you have slowed enough after leaving a high-speed roadway"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s7-disabled-vehicle-flashers",
    "q": "If you are having vehicle trouble and must stop:",
    "answer": {
      "text": "Turn on your emergency flashers to show your vehicle is disabled",
      "section": 7,
      "topic": "Communicating, Use emergency signals",
      "page": 68
    },
    "otherChoices": [
      "Stop just over a hill or just around a curve",
      "Stand on the roadway to warn approaching traffic"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s7-visual-lead",
    "q": "To identify potential problems in the travel path, you need a visual lead, an area _____ ahead from the front of the vehicle.",
    "answer": {
      "text": "20 to 30 seconds",
      "section": 7,
      "topic": "Visual Search, Seeing Well Ahead in the Travel Path",
      "page": 56
    },
    "otherChoices": ["4 to 6 seconds", "2 to 3 seconds"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s7-visibility-60-mph",
    "q": "At 60 mph, if you cannot see at least _____ ahead, you are driving too fast for your visibility.",
    "answer": {
      "text": "400 feet",
      "section": 7,
      "topic": "Visual Search",
      "page": 57
    },
    "otherChoices": ["150 feet", "200 feet"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s7-wet-roadway-speed-reduction",
    "q": "On wet roadways, to allow for additional stopping distance and potential traction loss while steering, you should reduce speed:",
    "answer": {
      "text": "About 10 mph below recommended speeds",
      "section": 7,
      "topic": "Speed Management, Slippery roads",
      "page": 59
    },
    "otherChoices": [
      "By half or more below recommended speeds",
      "Only for the first few minutes, until the oil is washed off the surface"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s7-signal-above-40-mph",
    "q": "At speeds above 40 mph, signal:",
    "answer": {
      "text": "200 feet or 3 to 5 seconds before making a turn or a lane change",
      "section": 7,
      "topic": "Communicating, Signaling Your Movements",
      "page": 69
    },
    "otherChoices": [
      "100 feet or 3 to 5 seconds before making a turn or a lane change",
      "500 feet before making a turn or a lane change"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s7-being-passed",
    "q": "Once aware that a vehicle wants to pass your vehicle, you should:",
    "answer": {
      "text": "Move to the right side of your lane and maintain a constant speed",
      "section": 7,
      "topic": "Space Management, Space to Pass",
      "page": 66
    },
    "otherChoices": ["Increase speed so the pass is completed sooner", "Move to the left portion of your lane space"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 2,
    "updatedAt": "2026-08-04",
    "status": "verified"
  },
  {
    "id": "authored:s7-no-passing-hills-curves",
    "q": "Treat a hill or curve ahead as an oncoming vehicle, and do not start to pass when within:",
    "answer": {
      "text": "1/3 of a mile of the hill or curve",
      "section": 7,
      "topic": "Space to Pass, Hills and curves",
      "page": 66
    },
    "otherChoices": ["A quarter of a mile of the hill or curve", "200 feet of the hill or curve"],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s7-turn-time-left-vs-right",
    "q": "When turning and entering traffic flow, you need enough space to complete the turn and get up to speed. Under normal circumstances:",
    "answer": {
      "text": "A right turn takes 12 to 15 seconds and a left turn takes 15 to 18 seconds",
      "section": 7,
      "topic": "Space Management, Space to Cross or Enter",
      "page": 65
    },
    "otherChoices": [
      "A left turn takes 12 to 15 seconds and a right turn takes 15 to 18 seconds",
      "Either turn can be completed within 3 to 5 seconds"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s7-horn-use-by-situation",
    "q": "Your vehicle's horn can get the attention of other roadway users. Use it whenever it will help prevent a crash:",
    "answer": {
      "text": "A light tap should be all that is needed under normal circumstances, and if there is danger, use a SHARP BLAST",
      "section": 7,
      "topic": "Communicating, Using your horn",
      "page": 68
    },
    "otherChoices": [
      "A SHARP BLAST should be all that is needed under normal circumstances, and if there is danger, use a light tap",
      "A tap of the horn is a good way to greet a friend or to tell another driver of an error"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s7-esp-traction-loss",
    "q": "If you lose traction in a vehicle with ESP (Electronic Stability Program), you should:",
    "answer": {
      "text": "Steer the vehicle toward the direction you are looking and avoid abrupt steering",
      "section": 7,
      "topic": "Traction Technology",
      "page": 62
    },
    "otherChoices": ["Steer abruptly to correct the traction loss", "Fixate on the hazard you are trying to avoid"],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s7-exit-lane-preparation",
    "q": "In heavy traffic, plan to get into the proper lane for your exit about:",
    "answer": {
      "text": "One-half mile before the exit",
      "section": 7,
      "topic": "Speed Management, Exiting traffic flow",
      "page": 60
    },
    "otherChoices": ["A quarter of a mile before the exit", "100 feet before the exit"],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 3,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s7-passing-oncoming-vehicle",
    "q": "When judging whether you have enough space to pass, if you can see an oncoming vehicle:",
    "answer": {
      "text": "Do not attempt to pass, because oncoming vehicles do not seem to be coming as fast as they really are",
      "section": 7,
      "topic": "Space Management, Space to Pass, Oncoming vehicles",
      "page": 66
    },
    "otherChoices": [
      "Pass if the oncoming vehicle appears to be standing still, since it must be more than 25 seconds away",
      "Determine the oncoming vehicle's speed and pass if there is enough time"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s7-look-left-right-left",
    "q": "You are stopped at an intersection. Before entering, you should look:",
    "answer": {
      "text": "Left, right and left again",
      "section": 7,
      "topic": "Visual Search, Intersections",
      "page": 57
    },
    "otherChoices": ["Right, left and right again", "Over your shoulder in the direction you plan to move"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 3,
    "updatedAt": "2026-08-04",
    "status": "verified"
  },
  {
    "id": "authored:s7-edge-forward-slowly",
    "q": "You have stopped at a stop sign, and your view of the cross street is blocked. You should:",
    "answer": {
      "text": "Edge forward slowly until you can see",
      "section": 7,
      "topic": "Visual Search, Crossing an Intersection",
      "page": 57
    },
    "otherChoices": [
      "Accelerate quickly across the intersection to clear it",
      "Proceed as soon as you have stopped, since traffic on the through street must yield to you"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s7-away-from-sun-headlights",
    "q": "When driving away from a rising or setting sun, you should turn on your headlights because:",
    "answer": {
      "text": "Drivers coming towards you may have trouble seeing your vehicle",
      "section": 7,
      "topic": "Communicating, Use headlights",
      "page": 68
    },
    "otherChoices": [
      "Your headlights will give you a better view of the travel path ahead",
      "Drivers behind you may have trouble seeing your vehicle"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s7-deceleration-lane",
    "q": "On a multiple-lane, limited access roadway, a deceleration lane (exit ramp) is used to:",
    "answer": {
      "text": "Reduce speed safely to exit traffic flow",
      "section": 7,
      "topic": "Speed Management, Exiting traffic flow",
      "page": 61
    },
    "otherChoices": ["Build up speed to match the flow of traffic", "Find a 4 to 6 second gap and merge into traffic"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  }
]
